/* eslint-disable multiline-ternary */
import { Box } from '@mui/material'
import React from 'react'
import { PropTypes } from 'prop-types'
import Button from '@mui/material/Button'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import ShareIcon from '@mui/icons-material/Share'
import './CustomButton.scss'
import config from '../config/config'
import { themeConfig } from '../config/theme.config'

export default function CustomButton({
  handleNext,
  disabled,
  helpText,
  showDisabledTooltip,
  btnLabel,
  fontWeight = 400,
  marginTop = 2,
  justifyContent = 'center',
  visibility = 'visible',
  withIcon = false,
  iconPlacementLeft = false,
  backgroundColor = config.themeConfig.semcogGreen,
  padding = '0px',
  borderRadius = '20px',
  showShareIcon = false,
  showZoomIcon = false,
  width,
  display = ''
}) {
  return (
    <Box
      mt={marginTop !== 0 ? marginTop : 0}
      className="btn-hover"
      sx={{
        display: display || 'grid',
        justifyContent,
        alignItems: 'center',
        visibility,
        padding,
        width
      }}
    >
      {' '}
      <Button
        variant="contained"
        size="small"
        style={
          disabled
            ? {
                margin: 'auto',
                padding: '0.5em 1.5em 0.5em 1.5em',
                fontSize: '14px',
                backgroundColor: themeConfig.semcogDarkGray,
                color: 'white',
                borderRadius,
                fontWeight,
                cursor: 'not-allowed',
                width
              }
            : {
                margin: 'auto',
                padding: '0.5em 1.5em 0.5em 1.5em',
                fontSize: '14px',
                backgroundColor,
                borderRadius,
                fontWeight,
                width
              }
        }
        disabled={disabled}
        onClick={handleNext}
        startIcon={
          withIcon && iconPlacementLeft ? (
            <KeyboardBackspaceIcon />
          ) : showShareIcon ? (
            <ShareIcon />
          ) : showZoomIcon ? (
            <ZoomInIcon />
          ) : (
            ''
          )
        }
        endIcon={withIcon && !iconPlacementLeft ? <ArrowRightAltIcon /> : ''}
      >
        {btnLabel || 'Continue'}
        {disabled && showDisabledTooltip && (
          <span className="help-text">
            {helpText || 'Fill in all blank inputs'}
          </span>
        )}
      </Button>
    </Box>
  )
}

CustomButton.propTypes = {
  handleNext: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showDisabledTooltip: PropTypes.bool,
  helpText: PropTypes.string,
  btnLabel: PropTypes.string,
  marginTop: PropTypes.number,
  visibility: PropTypes.string,
  justifyContent: PropTypes.string,
  withIcon: PropTypes.bool,
  backgroundColor: PropTypes.string,
  iconPlacementLeft: PropTypes.bool,
  padding: PropTypes.string,
  borderRadius: PropTypes.string,
  showShareIcon: PropTypes.bool,
  fontWeight: PropTypes.number,
  showZoomIcon: PropTypes.bool,
  width: PropTypes.string,
  display: PropTypes.string
}
